// ######################### Finding View Section Render Method #########################
// How are the sections rendered in the finding view?
// inline = sections are rendered one after another in a flat list.
// contained = sections are shown as cards.
export const sectionRenderMethod_Inline = 'inline';
export const sectionRenderMethod_Contained = 'contained';
export const sectionRenderMethods = [sectionRenderMethod_Inline, sectionRenderMethod_Contained];
// ######################### Finding View Section Type #########################
// Affects the way we group and display findings
// flat = findings that pass the rules and blacklist are rendered one after another in a flat list
// by-order = findings that pass the rules and blacklist are grouped by a common runtime order.
// fishbone = findings are grouped under a fishbone structure
// graph = findings are grouped under a graph where each line is a predetermined variable.
export const findingViewSectionType_Flat = 'flat';
export const findingViewSectionType_ByOrder = 'by-order';
export const findingViewSectionType_FishBone = 'fish-bone';
export const findingViewSectionType_Graph = 'graph';
export const findingViewSectionTypes = [findingViewSectionType_Flat,
    findingViewSectionType_ByOrder,
    findingViewSectionType_FishBone,
    findingViewSectionType_Graph];
//# sourceMappingURL=types.js.map